const styles = {
  root: {
    fill: 'none',
    fontSize: 24,
  },
} as const;
export default styles;
